module.exports = __webpack_public_path__ + "td/img/cost-virtual-1.561848ce.png";